<template>
  <div>
    <div class="corpo-pagina">
      <div class="row row-text">
        <div class="col s1"></div>
        <div class="col s10">

          <div v-if="orderedGroupedProducts.length > 0">
            <div
              v-for="block in orderedGroupedProducts"
              :key="block.typeName"
              class="pricing-block-group"
            >
              <h1 class="style color-black">{{ capitalize(block.typeName) }} Plans</h1>

              <div class="plans-wrapper">

                <div
                  v-for="plan in block.plans"
                  :key="plan.uid"
                  class="pricing-card"
                >
                    <div class="card-header">
                        <h3>{{ plan.name }}</h3>
                    </div>

                    <div class="card-body">
                        <p class="price-value">{{ formatCurrency(plan.price) }}</p>

                        <p class="quantity-detail">
                            {{ translation('pagina.prezzi.include')}}: {{ plan.quantity.toLocaleString(currentLocale) }} {{ getTypeSuffix(plan.type.name) }}
                        </p>

                        <p
                          v-if="plan.start_date && plan.end_date"
                          class="validity-detail"
                        >
                          {{ translation('pagina.prezzi.valido.dal')}}: **{{ formatDate(plan.start_date) }}**
                          <br/> {{ translation('pagina.prezzi.valido.al')}} : **{{ formatDate(plan.end_date) }}**
                        </p>

                        <table class="ul-list-table" v-if="plan.type.id === 2 || plan.type.id === 3">
                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list">
                                <span class="light">{{ formatCurrency(plan.sigle_price) }} {{ translation('Igotu.104') }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.100') }}</span></td>
                            </tr>
                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.101') }}</span></td>
                            </tr>
                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.102') }}</span></td>
                            </tr>

                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.103') }}</span></td>
                            </tr>
                          </table>

                          <table class="ul-list-table" v-if="plan.type.id === 1 || plan.type.id === 4">
                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list">
                                <span class="light">{{ formatCurrency(plan.sigle_price) }} {{ translation('Igotu.104') }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.pricing.email.001') }}</span></td>
                            </tr>
                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.pricing.email.002') }}</span></td>
                            </tr>

                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.pricing.email.003') }}</span></td>
                            </tr>

                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.pricing.email.004') }}</span></td>
                            </tr>

                            <tr>
                              <td class="td-list check"><i class="material-icons color-i">check</i></td>
                              <td class="td-list"><span class="light">{{ translation('Igotu.103') }}</span></td>
                            </tr>
                          </table>

                    </div>

                    <button
                      v-if="isAuth"
                      class="btn-small btn-add-to-cart"
                      @click="addToCart(plan)"
                    >
                      {{ translation('pagina.prezzi.aggiungi.carrello') || 'Aggiungi al Carrello' }}
                    </button>
                    <a href="/login" v-if="!isAuth" class="btn-small">Login</a>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-data"> - </div>

        </div>
        <div class="col s1"></div>
      </div>
    </div>

    <div>
      <SignUpFree v-if="!isAuth" />
    </div>
  </div>
</template>

<script>
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'
import SignUpFree from '@/components/SignUpFree.vue'
import apiService from '@/services/apiService.js'
import useAuthStore from '@/store/authStore.js'
import toast from '@/services/toast.js'
// Rimossi gli import relativi a PayPal e axios

export default {
  name: 'PricingView',
  data () {
    return {
      translationStore: translationStore,
      products: [],
      useAuthStore: useAuthStore,
      toast: toast
    }
  },
  components: {
    SignUpFree
  },
  computed: {
    isAuth () {
      return this.useAuthStore.getters.isAuthenticated
    },

    user () {
      return this.useAuthStore.getters.userInfo
    },

    currentUser () {
      const user = this.user
      return {
        uid: user?.uid
      }
    },

    translation () {
      return translationStore.getters.traduzione
    },

    /**
     * Usa la lingua corrente dallo store per la localizzazione (numeri e date).
     * Sostituisce '_' con '-' per il formato IETF BCP 47 (es. 'en_EN' -> 'en-EN').
     */
    currentLocale () {
      const locale = translationStore.state.linguaCorrente || 'it-IT'
      return locale.replace('_', '-')
    },

    isLoading () {
      return loadingStore.state.loading
    },

    /**
     * 1. Raggruppa i prodotti con logica mista:
     */
    groupedProducts () {
      if (this.products.length === 0) {
        return {}
      }
      const productsCopy = this.products.slice()
      const sortedProducts = productsCopy.sort((a, b) => {
        return a.order - b.order
      })

      return sortedProducts.reduce((acc, product) => {
        const fullName = product.type.name

        let groupKey

        if (fullName.startsWith('promozione.')) {
          groupKey = 'Promozione'
        } else {
          const parts = fullName.split('.')
          groupKey = parts.length > 1 ? parts[parts.length - 1] : fullName
        }

        if (!acc[groupKey]) {
          acc[groupKey] = []
        }
        acc[groupKey].push(product)
        return acc
      }, {})
    },

    /**
     * 2. Trasforma la mappa in un array ORDINATO di blocchi.
     */
    orderedGroupedProducts () {
      const groups = this.groupedProducts
      const preferredOrder = ['Promozione', 'checkins', 'emails']
      const orderedArray = []

      preferredOrder.forEach(typeName => {
        if (groups[typeName]) {
          orderedArray.push({
            typeName: typeName,
            plans: groups[typeName]
          })
        }
      })

      Object.keys(groups).forEach(typeName => {
        if (!preferredOrder.includes(typeName)) {
          orderedArray.push({
            typeName: typeName,
            plans: groups[typeName]
          })
        }
      })

      return orderedArray
    }
  },

  methods: {
    formatCurrency (value) {
      return new Intl.NumberFormat(this.currentLocale, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      }).format(value)
    },
    capitalize (s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },

    /**
     * Estrae il suffisso (checkins, emails, ecc.) dal nome completo del tipo.
     */
    getTypeSuffix (fullName) {
      if (typeof fullName !== 'string') return ''
      const parts = fullName.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : fullName
    },

    /**
     * Formatta una stringa data (es. '2025-10-21T00:00:00') nel formato locale.
     */
    formatDate (dateString) {
      const format = this.fullEventData?.timezone?.time_format || 'YYYY-MM-DD'
      const tz = this.fullEventData?.timezone?.timezone_name || 'UTC'

      return this.$formatEventDate(dateString, format, tz)
    },

    /**
     * Metodo: Aggiunge il piano al carrello (localStorage).
     * @param {Object} plan - L'oggetto piano da aggiungere.
     */
    addToCart (plan) {
      if (!this.isAuth) {
        this.$router.push('/login')
        return
      }

      try {
        // 1. Leggi il carrello esistente (o crea un array vuoto)
        const cartItems = JSON.parse(localStorage.getItem('listitem') || '[]')

        // 2. Controlla se il piano è già presente per evitare duplicati
        const exists = cartItems.some(item => item.uid === plan.uid)

        if (!exists) {
          // 3. Aggiungi il nuovo piano all'array
          cartItems.push(plan)

          // 4. Scrivi il carrello aggiornato su localStorage
          localStorage.setItem('listitem', JSON.stringify(cartItems))

          // 5. Lancia un evento fittizio per notificare all'Header di aggiornarsi
          window.dispatchEvent(new Event('storage'))

          // const addCar = `Aggiunto al carrello: ${plan.name}. Elementi totali: ${cartItems.length}`

          const addCar = this.translation('pagina-prezzi.toast.001').replace('{0}', plan.name).replace('{1}', cartItems.length)

          this.toast.createStampToast('thumb_up', addCar, 'toast-green')

          // TODO: Mostra una notifica "Prodotto aggiunto!"
        } else {
          const addCar = this.translation('pagina-prezzi.toast.002')
          this.toast.createStampToast('thumb_down', addCar, 'toast-red')
          // console.log(`Il piano ${plan.name} è già nel carrello.`)
        }
      } catch (e) {
        console.error("Errore nell'aggiunta al carrello:", e)
      }
    },

    // Rimossi: loadPayPalScript, renderPayPalButtons

    async getProducts () {
      loadingStore.commit('setLoading', true)
      try {
        const token = await apiService.getClientCredentialsToken()

        if (!token) {
          loadingStore.commit('setLoading', false)
          return
        }

        const url = process.env.VUE_APP_URL_EVENTS + '/products/get-products'
        const json = await apiService.sendRequestWithBearer('GET', url, token, null)
        this.products = json
      } catch (error) {
        // console.error('Errore nel recupero prodotti:', error)
        loadingStore.commit('setLoading', false)
      }
      loadingStore.commit('setLoading', false)
    }

  },

  created () {
    this.getProducts().then(() => {
      // Rimossa: this.loadPayPalScript()
      loadingStore.commit('setLoading', false)
    })
  }
}
</script>

<style scoped>
/* STILI ESISTENTI */
.plans-wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
}
.pricing-block-group {
    margin: 40px 0;
    padding: 15px;
    border-radius: 8px;
}
.pricing-card {
    flex: 1;
    min-width: 250px;
    max-width: 300px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;
}
.pricing-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.price-value {
    font-size: 2.2em;
    font-weight: bold;
    color: #4CAF50;
    margin: 10px 0 5px 0;
}

.ul-list-table {
    width: 100%;
    margin-top: 15px;
    text-align: left;
    border-collapse: collapse;
}
.td-list {
    padding: 5px 0;
    vertical-align: middle;
}
.td-list.check {
    width: 25px;
    text-align: center;
}
.color-i {
    color: #4CAF50; /* Icona check verde */
    font-size: 1.2em;
}
h1.style.color-black {
  color: black !important;
  font-size: 2em;
}
.no-data, .loading-state {
    text-align: center;
    padding: 30px;
    color: #777;
}

.validity-detail {
    font-size: 1.2em;
    color: #555;
    margin-top: 5px;
    margin-bottom: 10px;
    line-height: 1.4;
    font-weight: bold;
}

/* NUOVI STILI PER IL BOTTONE AGGIUNGI AL CARRELLO */
.btn-add-to-cart {
    width: 100%;
    margin-top: 15px;
}
</style>
